import { Quote } from 'lucide-react';
import { TESTIMONIAL_QUOTES } from '../../data/testimonials';

export default function QuoteStrip() {
  return (
    <section className="py-20 lg:py-28 bg-ivory" aria-label="Client testimonials">
      <div className="max-w-[1440px] mx-auto px-5 md:px-10">
        <div className="max-w-2xl reveal mb-12">
          <p className="text-[11px] tracking-[0.3em] uppercase text-champagne-deep mb-6">In Their Words</p>
          <h2 className="font-serif text-4xl lg:text-5xl leading-[1.05] text-charcoal">
            Quiet outcomes, <em className="italic-accent">spoken plainly.</em>
          </h2>
        </div>

        <div className="grid grid-cols-1 md:grid-cols-3 gap-px bg-charcoal/10 reveal">
          {TESTIMONIAL_QUOTES.map((t, i) => (
            <figure
              key={i}
              data-testid={`testimonial-${i + 1}`}
              className="bg-ivory p-8 lg:p-10 flex flex-col gap-6"
              itemScope
              itemType="https://schema.org/Review"
            >
              <Quote size={20} className="text-champagne-deep shrink-0" />
              <blockquote
                className="font-serif text-xl lg:text-2xl leading-[1.3] text-charcoal flex-1"
                itemProp="reviewBody"
              >
                &ldquo;{t.quote}&rdquo;
              </blockquote>
              <figcaption className="text-[10px] tracking-[0.3em] uppercase text-charcoal/55" itemProp="author">
                — {t.attribution}
              </figcaption>
              {/* Schema rating fallback to avoid Google warnings */}
              <span itemProp="reviewRating" itemScope itemType="https://schema.org/Rating" className="hidden">
                <span itemProp="ratingValue">5</span>
                <span itemProp="bestRating">5</span>
              </span>
            </figure>
          ))}
        </div>
      </div>
    </section>
  );
}
